import { createContext, useContext } from 'react';

export interface CmsLayoutConfig {
  contentWidth: 'narrow' | 'normal' | 'wide' | 'full';
  headerStyle: 'sticky' | 'static' | 'minimal';
  navPosition: 'top' | 'sidebar-left';
  footerStyle: 'none' | 'minimal' | 'full';
  headerMenuSlug?: string | null;
  footerMenuSlug?: string | null;
}

export const DEFAULT_LAYOUT: CmsLayoutConfig = {
  contentWidth: 'normal',
  headerStyle: 'sticky',
  navPosition: 'top',
  footerStyle: 'none',
  headerMenuSlug: null,
  footerMenuSlug: null,
};

export const CmsLayoutContext = createContext<CmsLayoutConfig>(DEFAULT_LAYOUT);

export function useCmsLayout(): CmsLayoutConfig {
  return useContext(CmsLayoutContext);
}
